<template>
    <skeleton :width="width" :height="height" style="border-radius: 16px" class="bg-gray-175" />
</template>

<script>
import Sizeable from "../../mixins/Sizeable";

    export default {
        name: 'ChipSkeleton',

        mixins: [Sizeable],

        props: {
            width: {
                default: 100,
                type: [String, Number],
            },
        },

        computed: {
            height() {
                switch (this.sizeString) {
                    case "xs":
                        return '16px';
                    case "sm":
                        return '24px';
                    case "lg":
                        return '54px';
                    case "xl":
                        return '54px';
                }
                return '34px';
            }
        }
    }
</script>

